import type { Theme, ThemeOptions } from '@mui/material/styles';

const BUTTON_SIZE = 36;
const ICON_SIZE = 18;

/** MUI overrides for the design-system ToggleButtonGroup (only elements with the `Sm*` classes). */
export function toggleButtonGroupThemeComponents(theme: Theme): ThemeOptions['components'] {
  return {
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          '&.SmToggleButtonGroup-root': {
            padding: 4,
            gap: 4,
            borderRadius: 10,
            backgroundColor: theme.palette.grey[600]
          }
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.SmToggleButton-root': {
            width: BUTTON_SIZE,
            height: BUTTON_SIZE,
            padding: 0,
            border: 'none',
            // Each button is its own rounded pill — not MUI's joined segments.
            borderRadius: '8px !important',
            margin: '0 !important',
            color: theme.palette.text.secondary,
            backgroundColor: 'transparent',
            '& .MuiSvgIcon-root': {
              fontSize: ICON_SIZE
            },
            '&:hover': {
              backgroundColor: theme.palette.action.hover
            },
            '&.Mui-selected, &.Mui-selected:hover': {
              color: theme.palette.common.white,
              backgroundColor: theme.palette.primary.main
            }
          }
        }
      }
    }
  };
}
